import * as React from 'react'
import { ApiError } from '$utils/services/apiErrorService'
import { ModalBox } from '../ModalBox'
import { Text } from '../Text'
import history from '$utils/history'
import { routeProvider } from '../../../utils/routeProvider'
import * as errorsText from '$views/components/Error/serverErrors'

interface Props {
  errors: ApiError
  title?: string
  simple?: boolean
  buttonLabel?: string
  onClick: () => void
}

export const ErrorNotification: React.SFC<Props> = ({ errors, title, buttonLabel, onClick }) => {
  if (errors.code === 401 || errors.data.MENSAJE_ERROR.find(mensaje => mensaje === 'UNAUTHORIZED')) {
    return (
      <ModalBox
        buttonLabel={'Aceptar'}
        onAcceptClick={() => {
          history.push(routeProvider.login)
        }}
        simple
        title={title}
      >
        Inicia sesión con tu usuario de Familiados para poder continuar
      </ModalBox>
    )
  }

  return (
    // tslint:disable-next-line
    <ModalBox title={title} simple onAcceptClick={onClick} buttonLabel={buttonLabel ? buttonLabel : 'Aceptar'}>
      {errors.data.MENSAJE_ERROR.map((msgError, index) => (
        <Text key={index}>
          {errorsText.errors[msgError.toLowerCase()]
            ? errorsText.errors[msgError.toLowerCase()]
            : errorsText.errors.default}
        </Text>
      ))}
    </ModalBox>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/ErrorNotification/ErrorNotification.tsx